import type { TFunction } from 'i18next';

import { MeinOrtNewsFilter } from '@/features/mein-ort/components/news-filter/newsFilterTypes';

type NewsFilterTFunction = TFunction<'my-place', 'screens.myPlace.newsFilter'>;

export type NewsFilterOption = {
  value: MeinOrtNewsFilter;
  label: string;
};

export const getNewsFilterOptions = (
  t: NewsFilterTFunction
): NewsFilterOption[] => [
  { value: MeinOrtNewsFilter.ALLE, label: t('alle') },
  { value: MeinOrtNewsFilter.RATHAUS, label: t('rathaus') },
  { value: MeinOrtNewsFilter.GEMEINDE, label: t('gemeinde') }
];
